const assert = require('assert');
const axios = require('axios');
const { v1:uuid } = require('uuid');
//const { TextEncoder } = require('util');
const crypto = require('crypto');
const printf = require('printf');

if (typeof TextEncoder === "undefined") {
  const encoding = require('text-encoding');
  window.TextEncoder = encoding.TextEncoder;
  window.TextDecoder = encoding.TextDecoder;
}

var log;

const PEPPER_ENV = process.env.PEPPER_ENV;

const FORMAT_VERSION = 1;

function make_metadata(size) {
  return {
    ctime: Date.now(),
    mtime: Date.now(),
    size: size,
  }
}

if (process.env.NODE_ENV == "development" || PEPPER_ENV == "test" || PEPPER_ENV == "dev") {
  log = console.log;
} else {
  log = () => {};
}

function blob_to_arraybuffer(blob) {
  var res;
  var promise = new Promise((resolve) => {
    res = resolve;
  });
  var fileReader = new FileReader();
  fileReader.onload = function(event) {
    res(event.target.result);
  };
  fileReader.readAsArrayBuffer(blob);
  return promise;
}

function obj_id_alloc() {
  return uuid();
}

function error(msg, params) {
  var e = new Error(msg);
  e.params = params;
  throw e;
}

function str2ab(str) {
  var encoder = new TextEncoder();
  return encoder.encode(str);
}

function ab2str(buf) {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}

function ab2base64(buf) {
  var str = String.fromCharCode.apply(null, new Uint8Array(buf));
  return window.btoa(str);
}

function generate_password(len=10, upper=true, number=true, special=false) {
  var c = "abcdefghjkmnpqrstuvwxyz";
  var r = [];
  var l;
  if (upper) {
    l = 'ABCDEFGHJKLMNPQRSTURVXYZ';
    c += l;
    r.push(l[Math.floor((Math.random() * 1000)) % l.length]);
  }
  if (number) {
    l = '23456789';
    c += l;
    r.push(l[Math.floor((Math.random() * 1000)) % l.length]);
  }
  if (special) {
    l = "!@#$%^&*_-=";
    c += l;
    r.push(l[Math.floor((Math.random() * 1000)) % l.length]);
  }
  for (var i = r.length; i < len; i++) {
    r.push(c[Math.floor((Math.random() * 1000)) % c.length]);
  }
  r.sort(() => Math.random() - 0.5);
  return r.join('');
}

function encrypt_slow(enc_info, buf) {
  var cipher = crypto.createCipheriv('aes-256-cbc', enc_info.key, new Buffer(enc_info.iv));
  var ret = cipher.update(buf);
  var rem = cipher.final();
  var r = Buffer.concat([ret, rem]);
  return r
}

function has_native_crypto() {
  return typeof window !== 'undefined' && window.isSecureContext;
}

async function encrypt_fast(enc_info, buf) {
  var key = await window.crypto.subtle.importKey(
    'raw',
    enc_info.key,
    {
      name: 'AES-CBC',
      length: 256,
    },
    true,
    ['encrypt', 'decrypt']
  );
  return await window.crypto.subtle.encrypt(
    {
      name: "AES-CBC",
      iv: Buffer.from(enc_info.iv),
    },
    key,
    buf,
  );
}

async function encrypt(enc_info, data) {
  var buf = Buffer.from(data);
  var r;
  if (has_native_crypto()) {
    r = await encrypt_fast(enc_info, buf);
  } else {
    r = await encrypt_slow(enc_info, buf);
  }
  return r;
}

async function decrypt_slow(enc_info, buf) {
  var decipher = crypto.createDecipheriv('aes-256-cbc', enc_info.key, new Buffer(enc_info.iv));
  try {
    var ret = decipher.update(buf);
    var rem = decipher.final();
  } catch (e) {
    error("EKEYREJECTED");
  }
  return Buffer.concat([ret, rem]);
}

async function decrypt_fast(enc_info, buf) {
  var key = await window.crypto.subtle.importKey(
    'raw',
    enc_info.key,
    {
      name: 'AES-CBC',
      length: 256,
    },
    true,
    ['encrypt', 'decrypt']
  );
  var ret = await window.crypto.subtle.decrypt(
    {
      name: "AES-CBC",
      iv: Buffer.from(enc_info.iv),
    },
    key,
    buf,
  );
  return Buffer.from(ret);
}

async function decrypt(enc_info, data) {
  var buf = Buffer.from(data);
  var r;
  if (has_native_crypto()) {
    r = await decrypt_fast(enc_info, buf);
  } else {
    r = await decrypt_slow(enc_info, buf);
  }
  return r;
}

async function decrypt_with_private_key(private_key, data) {
  var d = Uint8Array.from(atob(private_key), c => c.charCodeAt(0))
  var key = await window.crypto.subtle.importKey(
    'pkcs8',
    d,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-512',
    },
    true,
    ['decrypt']
  );
  log(key);
  log("data", data);
  var decrypted = await window.crypto.subtle.decrypt(
    {
      name: "RSA-OAEP"
    },
    key,
    data);
  log("decrypted:", decrypted);
  return decrypted;
}

async function encrypt_with_public_key(pub_key, data) {
  var d = Uint8Array.from(atob(pub_key), c => c.charCodeAt(0))
  var key = await window.crypto.subtle.importKey(
    'spki',
    d,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-512',
    },
    true,
    ['encrypt']
  );
  var buf = str2ab(data);
  var encrypted = await window.crypto.subtle.encrypt(
    {
      name: "RSA-OAEP"
    },
    key,
    buf);
  log("encrypted:", encrypted);
  return encrypted;
}

function path_split(path) {
  var ps = path.split('/');
  if (ps[ps.length - 1] == '') {
    return ps.slice(0, ps.length -1);
  } else {
    return ps;
  }
}

class EncInfo {
  constructor(passphrase, salt=null, iv=null) {
    this.passphrase = passphrase || generate_password();
    this.salt = salt || generate_password();
    this.iv = iv || this.make_random(16);
    this.iterations = 100;
    this._key = null;
  }

  get json() {
    return {
      passphrase: this.passphrase,
      salt: this.salt,
      iv: this.iv,
      iterations: this.iterations,
    }
  }

  make_random(len) {
    var ret = [];
    for (var i = 0; i < len; i++) {
      ret.push(Math.floor(Math.random() * 256));
    }
    return ret;
  }

  get key() {
    if (!this._key) {
      this._key = crypto.pbkdf2Sync(this.passphrase, this.salt, this.iterations, 32, 'sha512');
    }
    return this._key;
  }
}

class PepperFsNode {
  constructor(client, name, obj_id, enc_info, type, parent_dir, metadata) {
    assert(enc_info, "missing enc_info at constructor");
    this.client = client;
    this.name = name;
    this.obj_id = obj_id;
    this.enc_info = enc_info;
    this.type = type;
    this.parent_dir = parent_dir;
    this.data = null;
    this.metadata = metadata;
    this.mutated = false;
    this.old_obj_id = null;
  }

  get is_synced() {
    return !this.mutated;
  }

  get isdir() {
    return this.type == "dir";
  }

  get populated() {
    return this.data != null;
  }

  get size() {
    return this.metadata ? this.metadata.size : 0;
  }

  encrypted_data() {
    var j = JSON.stringify(this.data);
    var b = str2ab(j);
    return encrypt(this.enc_info, b);
  }

  get ctime() {
    return this.metadata ? new Date(this.metadata.ctime) : new Date();
  }

  get mtime() {
    return this.metadata ? new Date(this.metadata.mtime) : new Date();
  }

  get path() {
    var r = [];
    for (var p = this; p.parent_dir; p = p.parent_dir) {
      assert(p.name, "non-root parent has no name?");
      r.unshift(p.name);
    }
    return "/" + r.join("/");
  }

  get dentry() {
    return {
      name: this.name,
      type: this.type,
      metadata: this.metadata,
      obj_id: this.obj_id,
      enc_info: this.enc_info.json,
    };
  }

  get root() {
    var p = this;
    while (p.parent_dir) {
      p = p.parent_dir;
    }
    return p;
  }

  stage() {
    return this.client.set_json(this.obj_id, this.data, this.enc_info);
  }

  async populate() {
    if (this.populated) {
      return;
    }
    var data = await this.client.get_json(this.obj_id, this.enc_info);
    if (this.populated) {
      return;
    }
    if (data.version != FORMAT_VERSION) {
      error("unknown format version: " + data.version);
    }
    this.data = data;
    this.parse_data();
    assert(this.populated, "Bug in populate()");
  }

  mutate() {
    if (!this.mutated) {
      this.old_obj_id = this.obj_id;
      this.obj_id = obj_id_alloc();
      this.root.mutated_nodes.add(this);
      this.mutated = true;
    }
  }

  unmutate() {
    this.obj_id = this.old_obj_id;
    this.mutated = false
  }

  mutate_recursive() {
    for (var p = this; p; p = p.parent_dir) {
      p.mutate();
      if (p.parent_dir) {
        p.parent_dir.replace_child(p.name, p);
      }
    }
  }
}

class PepperFsFile extends PepperFsNode {
  constructor(client, name, obj_id, enc_info, parent_dir, metadata) {
    super(client, name, obj_id, enc_info, "file", parent_dir, metadata);
  }

  async clone() {
    await this.populate();
    var r = new PepperFsFile(
      this.client,
      this.name,
      obj_id_alloc(),
      this.enc_info,
      null,
      this.metadata);
    r.data = JSON.parse(JSON.stringify(this.data));
    r.parse_data();
    return r;
  }

  parse_data() {
  }

  get refs() {
    return this.data.chunks;
  }

  initialize_data() {
    this.data = {
      version: FORMAT_VERSION,
      chunks: [],
      type: "file",
    };
  }
}

class PepperFsDir extends PepperFsNode {
  constructor(client, name, obj_id, enc_info, parent_dir, metadata) {
    super(client, name, obj_id, enc_info, "dir", parent_dir, metadata);
    this._children = null;
    if (!parent_dir) {
      this.mutated_nodes = new Set();
    }
  }

  is_parent_of(dir) {
    for (var k = dir; k; k = k.parent_dir) {
      if (k == this) {
        return true;
      }
    }
  }

  async clone() {
    await this.populate();
    var r = new PepperFsDir(
      this.client,
      this.name,
      obj_id_alloc(),
      this.enc_info,
      null,
      this.metadata);
    r.data = JSON.parse(JSON.stringify(this.data));
    r.parse_data();
    return r;
  }

  parse_data() {
    assert(this.data);
    assert.equal(this._children, null);
    this._children = this.data.children.map(c => {
      var ei = c.enc_info;
      var enc_info = new EncInfo(ei.passphrase, ei.salt, ei.iv);
      if (c.type == 'dir')
        return new PepperFsDir(this.client, c.name, c.obj_id, enc_info, this, c.metadata);
      else if (c.type == 'file')
        return new PepperFsFile(this.client, c.name, c.obj_id, enc_info, this, c.metadata);
      else
        error('Invalid child type: ' + c.type);
    });
  }

  get refs() {
    return this.children.map(c => c.obj_id);
  }

  get children() {
    assert(this.populated);
    return this._children;
  }

  find_child(name) {
    var r = this.children.filter(c => c.name == name);
    if (r.length) {
      return r[0];
    }
    return null;
  }

  initialize_data() {
    this.data = {
      version: FORMAT_VERSION,
      children: [],
      type: "dir",
    };
    this.parse_data();
  }

  add_child(c) {
    if (this.children.filter(x => x.name == c.name).length > 0) {
      error("EEXIST", { name: c.name });
    }
    if (this.children.length >= 65535) {
      error("ETOOMANY");
    }
    this._children.push(c);
    this.data.children.push(c.dentry);
    c.parent_dir = this;
    this.update_size();
    this.mutate_recursive();
  }

  replace_child(name, child) {
    this._children = this._children.map(c => {
      if (c.name == child.name) {
        return child;
      }
      return c;
    });

    this.data.children = this.data.children.map(c => {
      if (c.name == name) {
        return child.dentry;
      }
      return c;
    });
    this.update_size();
    this.mutate_recursive();
  }

  rename_child(child, newname) {
    var oldname = child.name;
    var new_children = this.data.children.map(c => {
      if (c.name == newname) {
        error("EEXIST", { name: newname });
      }
      if (c.name == oldname) {
        c.name = newname;
      }
      return c;
    });
    child.name = newname;
    this.data.children = new_children;
    this.mutate_recursive();
  }

  remove_child(child) {
    var name = child.name;
    this._children = this._children.filter(c => c.name != name);
    this.data.children = this.data.children.filter(c => c.name != name);
    this.update_size();
    this.mutate_recursive();
  }

  update_size() {
    if (!this.metadata) {
      return;
    }
    var size = 0;
    for (var c of this.children) {
      size += c.size;
    }
    this.metadata.size = size;
  }
}

class PepperStorageSpace {
  constructor(client, name, enc_info, root_obj_id) {
    this.client = client;
    this.name = name;
    this.enc_info = enc_info;
    this.root_obj_id = root_obj_id;
    this.root = new PepperFsDir(client, "", root_obj_id, enc_info, null);
    this.ops = [];
    this.waiters = [];
    this.processing_ops = false;
  }

  validate_name(name) {
    if (!name.length) {
      error("Zero length name is invalid");
    }
    if (name.length >= 260) {
      error("ETOOLONG");
    }
    const invalid_chars = "/\\:\"<>#$%^&*|\t\b";
    for (var i = 0; i < name.length; i++) {
      var c = name[i];
      if (invalid_chars.includes(c)) {
        error("Invalid char in path name: " + c);
      }
    }
  }

  path_join(a, b) {
    var x = a.split("/").filter(x => x.length > 0);
    var y = b.split("/").filter(x => x.length > 0);
    var r = '/' + x.concat(y).join('/');
    return r;
  }

  path_last(path) {
    return path.split('/').pop();
  }

  path_ext(path) {
    var i = path.lastIndexOf(".");
    if (i <= 0) {
      return '';
    }
    return path.slice(i + 1);
  }

  dirname(p) {
    var c = p.split('/').filter(x => x.length > 0)
    return "/" + c.slice(0, c.length - 1).join("/");
  }

  is_image(name) {
    var ext = this.path_ext(name).toLowerCase();
    switch (ext) {
      case 'jpg':
      case 'png':
      case 'jpeg':
      case 'bmp':
        return true;
      default:
        return false;
    }
  }

  get is_synced() {
    return this.root.mutated_nodes.size == 0;
  }

  wait_ops() {
    return new Promise((resolve, reject) => {
      this.waiters.push({ resolve, reject });
    });
  }

  async apply_ops() {
    if (this.processing_ops) {
      return;
    }
    var failed = false;
    this.processing_ops = true;
    var reason;
    while (this.ops) {
      try {
        var changes = [];
        for (var op of this.ops) {
          var change = await op();
          if (change) {
            changes.push(change);
          }
        }
        if (this.root.mutated_nodes.size == 0) {
          break;
        }
        var objs = [];
        for (var m of this.root.mutated_nodes) {
          var encrypted = await m.encrypted_data();
          var buf = Buffer.from(encrypted);
          objs.push({
            param: {
              id: m.obj_id,
              size: buf.length,
              refs: m.refs,
            },
            encrypted: buf,
          });
        }
        var urls = await this.client.objs_alloc(objs.map(o => o.param));
        var batch = [];
        for (var i in objs) {
          batch.push(this.client.put_raw(urls[i], objs[i].encrypted));
        }
        await Promise.all(batch);
        await this.client.swap_root(this.name, this.root_obj_id, this.root.obj_id,
          changes.filter(c => c.op));
        this.root_obj_id = this.root.obj_id;
      } catch (e) {
        if (e.response && e.response.status == 412) {
          // TODO: the response carried the new root obj id
          await this.refetch_root(e.response.data.root_obj_id);
          continue;
        }
        for (var c of changes) {
          try {
            await c.undo();
          } catch (e) {
            console.log("Error happened while trying to undo op:", c);
            console.log(e);
          }
        }
        failed = true;
        reason = e;
      }
      break;
    }
    this.ops = [];
    this.enc_info = this.root.enc_info;
    for (i of this.root.mutated_nodes) {
      if (failed) {
        i.unmutate();
      } else {
        i.mutated = false;
      }
    }
    this.root.mutated_nodes.clear();
    if (!failed) {
      this.root_obj_id = this.root.obj_id;
    }
    this.processing_ops = false;
    this.waiters.forEach(w => failed ? w.reject(reason) : w.resolve());
    this.waiters = [];
  }

  async refetch_root(obj_id) {
    this.root_obj_id = obj_id;
    this.root = new PepperFsDir(this.client, "", obj_id, this.enc_info, null);
  }

  async apply_op(op) {
    if (this.processing_ops) {
      await this.wait_ops();
    }
    assert(!this.processing_ops);
    this.ops.push(op);
    process.nextTick(this.apply_ops.bind(this));
    return this.wait_ops();
  }

  async fetch(path) {
    log("fetch", path);
    assert(path.startsWith('/'), "Path is not abosolute");
    await this.root.populate();
    var ps = path_split(path).slice(1);
    var pd = this.root;
    for (var p of ps) {
      await pd.populate();
      var n = pd.find_child(p);
      if (!n) {
        return null;
      }
      pd = n;
    }
    return pd;
  }

  save_file(path, size, chunks, enc_info, op) {
    var name = this.path_last(path);
    var metadata = make_metadata(size);
    var fo = new PepperFsFile(
      this.client, name, null, enc_info, null, metadata);
    fo.initialize_data();
    fo.data.chunks = chunks;
    return this.add_child(this.dirname(path), fo, op);
  }

  async rename_do(path, name) {
    assert(path != "/");
    var x = await this.fetch(path);
    if (!x) {
      error("ENOENT");
    }
    x.parent_dir.rename_child(x, name);
    var new_name = this.path_join(this.dirname(path), name);
    return {
      op: 'rename',
      path: new_name,
      orig: path,
      undo: () => {
        return this.rename_do(new_name, this.path_last(path));
      },
    };
  }

  rename(path, name) {
    return this.apply_op(() => {
      return this.rename_do(path, name);
    });
  }

  async move_do(path, dst) {
    var x = await this.fetch(path);
    if (!x) {
      error("ENOENT");
    }
    var dir = await this.fetch(dst);
    if (!dir) {
      error("ENOENT");
    } else if (dir.type != "dir") {
      error("EINVAL");
    }
    await dir.populate();
    if (x.isdir && x.is_parent_of(dir)) {
      error("EINVAL");
    }
    var old_parent = x.parent_dir;
    dir.add_child(x);
    old_parent.remove_child(x);
    var new_path = this.path_join(dst, x.name);
    return {
      op: 'move',
      path: new_path,
      orig: path,
      undo: () => {
        return this.move_do(new_path, this.dirname(path));
      },
    };
  }

  move(path, dst) {
    log("move", path, dst);
    return this.apply_op(() => {
      return this.move_do(path, dst);
    });
  }

  async copy_do(path, dst) {
    var x = await this.fetch(path);
    if (!x) {
      error("ENOENT");
    }
    var dir = await this.fetch(dst);
    if (!dir) {
      error("ENOENT");
    } else if (dir.type != "dir") {
      error("EINVAL");
    }
    log("populate");
    await dir.populate();
    if (x.isdir && x.is_parent_of(dir)) {
      error("EINVAL");
    }
    x = await x.clone();
    log("cloned child", x);
    this.root.mutated_nodes.add(x);
    dir.add_child(x);
    var new_path = this.path_join(dst, x.name);
    return {
      op: 'copy',
      path: new_path,
      orig: path,
      undo: () => {
        return this.remove_do(new_path);
      },
    };
  }

  copy(path, dst) {
    log("copy", path, dst);
    return this.apply_op(() => {
      return this.copy_do(path, dst);
    });
  }

  async add_child_do(path, child, op, no_mutate) {
    var dir = await this.fetch(path);
    if (!dir) {
      log("cannot find path", path);
      error("ENOENT");
    }
    if (dir.type != 'dir') {
      error("EINVAL");
    }
    await dir.populate();
    child.parent_dir = dir;
    if (!no_mutate) {
      child.mutate();
    }
    dir.add_child(child);
    var p = this.path_join(path, child.name);
    return {
      op: op,
      path: p,
      undo: () => {
        dir.remove_child(child);
      },
    };
  }

  add_child(path, child, op, no_mutate) {
    log("add child", path, child, op, no_mutate)
    return this.apply_op(() => {
      return this.add_child_do(path, child, op, no_mutate);
    });
  }

  async mkdir_do(path, op) {
    var ps = path_split(path).slice(1);
    var pd = this.root;
    var changed = false;
    var top_node = null;
    for (var i = 0; i < ps.length; i++ ) {
      var p = ps[i];
      await pd.populate();
      var node = pd.find_child(p);
      changed = !node;
      if (!node) {
        top_node = top_node || node;
        var obj_id = obj_id_alloc();
        node = new PepperFsDir(this.client, p, obj_id, this.enc_info, pd, make_metadata(0));
        node.initialize_data();
        this.root.mutated_nodes.add(node);
        pd.add_child(node);
      }
      pd = node;
    }
    if (changed) {
      return {
        op: op,
        path: path,
        undo: () => {
          if (top_node) {
            top_node.parent_dir.remove_child(top_node);
          }
        },
      };
    }
  }

  mkdir(path, op='mkdir') {
    log("mkdir", path);
    return this.apply_op(() => {
      return this.mkdir_do(path, op);
    });
  }

  async remove_do(path) {
    assert(path != "/");
    var x = await this.fetch(path);
    if (!x) {
      error("ENOENT");
    }
    var parent_dir = x.parent_dir;
    x.parent_dir.remove_child(x);
    return {
      op: 'delete',
      path: path,
      undo: () => {
        parent_dir.add_child(x);
      },
    }
  }

  remove(path) {
    return this.apply_op(() => {
      return this.remove_do(path);
    });
  }

  async set_passphrase_do(passphrase) {
    this.root.mutate();
    var ei = this.enc_info;
    var old_passphrase = ei.passphrase;
    this.root.enc_info = new EncInfo(passphrase, ei.salt, ei.iv);
    return {
      op: 'set-passphrase',
      undo: () => {
        return this.set_passphrase_do(old_passphrase);
      },
    };
  }

  set_passphrase(passphrase) {
    return this.apply_op(() => {
      return this.set_passphrase_do(passphrase);
    });
  }

  async replace_child_do(dirpath, child, op) {
    var dir = await this.fetch(dirpath);
    if (!dir) {
      error("ENOENT");
    }
    await dir.populate();
    var old_child = dir.find_child(child.name);
    child.parent_dir = dir;
    child.mutate();
    dir.replace_child(child.name, child);
    var path = this.path_join(dirpath, child.name);
    return {
      op: op,
      path: path,
      undo: () => {
        if (old_child) {
          return this.replace_child_do(dirpath, old_child);
        }
      },
    };
  }

  replace_child(dirpath, child, op) {
    return this.apply_op(() => {
      return this.replace_child_do(dirpath, child, op);
    });
  }

  async read_file(path) {
    var node = await this.fetch(path);
    if (!node) {
      error("ENOENT");
    }
    if (node.type != "file") {
      error("ENOTFILE");
    }
    await node.populate();
    var buf = Buffer.from([]);
    for (var cid of node.data.chunks) {
      buf = Buffer.concat([buf, await this.client.get(cid, node.enc_info)]);
    }
    return buf;
  }

  async read_json_file(path) {
    return JSON.parse(await this.read_file(path));
  }

  async write_file(path, data, op, nocreate=false) {
    var old = null;
    try {
      old = await this.fetch(path);
    } catch (e) {
      if (nocreate) {
        throw e;
      }
    }
    var dirpath = this.dirname(path);
    await this.mkdir(dirpath);
    var name = path.slice(path.lastIndexOf('/') + 1);
    this.validate_name(name);
    var chunk_id = obj_id_alloc();
    var md;
    if (old) {
      md = old.metadata;
      md.mtime = Date.now();
      md.size = data.byteLength;
    } else {
      md = make_metadata(data.byteLength);
    }
    var fo = new PepperFsFile(this.client, name, "", new EncInfo(), null, md);
    fo.initialize_data();
    await this.client.set(chunk_id, data, fo.enc_info);
    fo.data.chunks = [chunk_id];
    if (old) {
      await this.replace_child(dirpath, fo, op);
    } else {
      await this.add_child(dirpath, fo, op);
    }
  }

  write_json_file(path, obj, op, nocreate=false) {
    return this.write_file(path, str2ab(JSON.stringify(obj)), op, nocreate);
  }
}

class PepperClient {
  constructor(server) {
    if (server.endsWith('/')) {
      server = server.slice(0, server.length - 1);
    }
    this.server = server;
    this._spaces = [];
    this._userinfo = null;
    this.quota = null;
    this.coupons = [];
    this.resource_packs = null;
    this.token = null;
  }

  async get_json(obj_id, enc_info) {
    var d = await this.get(obj_id, enc_info);
    return JSON.parse(d);
  }

  async get(obj_id, enc_info) {
    var raw = await this.get_raw("/v1/obj/" + obj_id + "/");
    var decrypted = await decrypt(enc_info, raw);
    return decrypted;
  }

  async direct_set(obj_id, data, url) {
    var buf = Buffer.from(data);
    if (!url) {
      url = await this.obj_alloc(obj_id, buf.length);
    }
    return await this.put_raw(url, data);
  }

  async obj_alloc(obj_id, size) {
    var r = await this.objs_alloc([{
      id: obj_id,
      size: size,
    }]);
    return r[0];
  }

  async objs_alloc(objs) {
    var r = await this.call_api("POST", "/v1/objs/alloc/", {
      objs
    });
    return r.urls;
  }

  async set(obj_id, buf, enc_info, url) {
    assert(enc_info && enc_info.key, "we must be secure!");
    var encrypted = await encrypt(enc_info, buf);
    return await this.direct_set(obj_id, encrypted, url);
  }

  ref_obj(obj_id, refs) {
    assert(refs, "refs cannot be empty")
    return this.call_api("PUT", "/v1/obj/" + obj_id + "/refs/", {
      obj_ids: refs,
    });
  }

  async swap_root(fs, old_id, new_id, changes) {
    log("swap root, old -> new: ", old_id, new_id);
    var resp = await this.call_api("POST", "/v1/space/swap-root/", {
      name: fs,
      old_id: old_id,
      new_id: new_id,
      description: changes,
    });
    this.quota = resp.quota;
    return true;
  }

  put_raw(url, data, headers={}) {
    headers['Content-Type'] = 'application/octet-stream';
    if (this.token) {
      headers['Authorization'] = "Token " + this.token;
    }
    if (url.startsWith("/")) {
      url = this.server + url;
    } else {
      assert(url.startsWith("http://") || url.startsWith("https://"));
    }
    return axios.put(url, data, {
      headers: headers,
    });
  }

  get_raw(url) {
    var headers = {}
    if (this.token) {
      headers['Authorization'] = "Token " + this.token;
    }
    return axios.get(this.server + url, {
      headers: headers,
      responseType: 'arraybuffer',
    }).then(resp => {
      return resp.data;
    }).catch(e => {
      if (this.api_error_cb) {
        this.api_error_cb(e);
      }
      throw e;
    });
  }

  set_json(obj_id, data, enc_info) {
    var j = JSON.stringify(data);
    var b = str2ab(j);
    return this.set(obj_id, b, enc_info);
  }

  subscribe(email) {
    return this.call_api("POST", "/v1/subscribe/", {
      email: email,
    });
  }

  get authenticated() {
    return this.token != null;
  }

  create_order(plan, months, total, coupon, upgrade) {
    return this.call_api("POST", "/v1/order/", {
      plan,
      months,
      total,
      coupon,
      upgrade,
    });
  }

  mobile_send_token(mobile) {
    return this.call_api("POST", "/v1/register/mobile-send-token/", {
      mobile: mobile,
    });
  }

  check_sms(mobile, token) {
    return this.call_api("POST", "/v1/register/mobile-check-token/", {
      mobile: mobile,
      token: token,
    });
  }

  register(mobile, token, email) {
    return this.call_api("POST", "/v1/register/", {
      mobile: mobile,
      token: token,
      email: email,
    });
  }

  set_password(token, password) {
    return this.call_api("POST", "/v1/verify-email/" + token + "/", {
      password: password,
    });
  }

  reset_password_request_sms(email) {
    return this.call_api("POST", "/v1/reset-password/send-sms/", {
      "email": email,
    });
  }

  reset_password_verify_sms(email, sms_code) {
    return this.call_api("POST", "/v1/reset-password/send-email/", {
      "email": email,
      "mobile_token": sms_code,
    });
  }

  reset_password_complete(token, password, old_password, sms_code) {
    return this.call_api("POST", "/v1/reset-password/complete/", {
      email_token: token,
      password: password,
      old_password: old_password,
      sms_code: sms_code,
    });
  }

  parse_userinfo(ui) {
    this._userinfo = ui;
    this.quota = ui.quota;
    this.coupons = ui.coupons;
    this.resource_packs = ui.resource_packs;
  }

  login(username, password) {
    return this.call_api("POST", "/v1/auth/login/", {
      username: username,
      password: password,
    }).then(data => {
      var token = data.token;
      this.token = token;
      if (data.userinfo) {
        this.parse_userinfo(data.userinfo);
      }
    });
  }

  logout() {
    if (this.authenticated) {
      return this.call_api("POST", "/v1/auth/logout/");
    }
    this._userinfo = null;
    this.token = null;
  }

  revoke_token(token) {
    return this.call_api("POST", "/v1/auth/revoke-token/", {
      token: token,
    });
  }

  fetch_space_history(space, start, end, page, keywords='') {
    start /= 1000;
    end /= 1000;
    return this.call_api("GET",
      `/v1/space/versions/?start=${start}&end=${end}&page=${page}&keywords=${keywords}`);
  }

  fetch_activities() {
    return this.call_api("GET", "/v1/user-activities/");
  }

  fetch_orders() {
    return this.call_api("GET", "/v1/orders/");
  }

  fetch_order(tid, payment_method='') {
    return this.call_api("GET", "/v1/order/?tid=" + tid + "&payment_method=" + payment_method);
  }

  request_refund(tid, reason) {
    return this.call_api("POST", "/v1/refund/request/", {
      tid: tid,
      reason: reason,
    });
  }

  get plan() {
    return this._userinfo ? this._userinfo.plan : null;
  }

  async fetch_plans() {
    if (!this.plans) {
      this.plans = await this.call_api("GET", "/v1/plans/");
    }
    return this.plans;
  }

  alipay_url(tid) {
    return this.server + "/v1/pay/alipay/?tid=" + tid;
  }

  get display_name() {
    return this._userinfo ? this._userinfo.display_name : null;
  }

  async set_display_name(new_name) {
    var ui = await this.call_api("PATCH", "/v1/userinfo/", {
      "display_name": new_name,
    });
    this.parse_userinfo(ui);
  }

  get spaces() {
    return this._spaces;
  }

  async fetch_spaces() {
    this._spaces = await this.call_api("GET", "/v1/spaces/");
    return this._spaces;
  }

  async open_space(name, passphrase, root_obj_id) {
    assert(this.authenticated, 'Must authenticate first');
    assert(passphrase);
    await this.fetch_spaces();
    var match = this._spaces.filter(x => x.name == name);
    if (!match.length) {
      error('ENOENT');
    }
    var m = match[0];
    var ei = JSON.parse(m.enc_info);
    var enc_info = new EncInfo(passphrase, ei.salt, ei.iv);
    var space = new PepperStorageSpace(this, name, enc_info,
      root_obj_id ? root_obj_id : m.root_obj_id);
    await space.fetch('/');
    return space;
  }

  async reset_passphrase(name, recovery_code, new_passphrase) {
    assert(this.authenticated, 'Must authenticate first');
    assert(recovery_code)
    assert(new_passphrase);
    await this.fetch_spaces();
    var match = this._spaces.filter(x => x.name == name);
    if (!match.length) {
      error('ENOENT');
    }
    var m = match[0];
    var ei = JSON.parse(m.enc_info);
    var recovery_data = ei.recovery_data;
    if (!recovery_data) {
      error("ENOTSUP");
    }
    var data = new Buffer(recovery_data, 'base64');
    var rei = new EncInfo(recovery_code, ei.salt, ei.iv);
    var old_passphrase = (await decrypt(rei, data)).toString();
    var sp = await this.open_space(name, old_passphrase);
    await sp.set_passphrase(new_passphrase);
    var rc = this.generate_recovery_code();
    await this.set_recovery_code(sp, new_passphrase, rc);
    return rc;
  }

  async make_space_enc_info(ei, passphrase, recovery_code) {
    var recovery_data = null;
    if (recovery_code) {
      var rei = new EncInfo(recovery_code, ei.salt, ei.iv);
      var ed = await encrypt(rei, passphrase);
      recovery_data = Buffer.from(ed).toString('base64');
    }
    return {
      method: "AES-CBC-256",
      salt: ei.salt,
      iv: ei.iv,
      iterations: ei.iterations,
      recovery_data: recovery_data,
    };
  }

  async set_recovery_code(sp, passphrase, recovery_code) {
    var ei = await this.make_space_enc_info(sp.enc_info, passphrase, recovery_code);
    return await this.call_api("POST", "/v1/space/set-enc-info/", {
      name: sp.name,
      enc_info: JSON.stringify(ei),
    });
  }

  obj_id_alloc() {
    return obj_id_alloc();
  }

  generate_password(len=10, upper=true, number=true, special=false) {
    return generate_password(len, upper, number, special);
  }

  generate_recovery_code() {
    return generate_password(16, false, true, false);
  }

  async generate_rsa_keypair() {
    var kp = await window.crypto.subtle.generateKey(
      {
        name: "RSA-OAEP",
        modulusLength: 4096,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: "SHA-512",
      },
      true,
      ["encrypt", "decrypt"]
    );
    var public_key = await window.crypto.subtle.exportKey(
      'spki',
      kp.publicKey);
    var private_key = await window.crypto.subtle.exportKey(
      'pkcs8',
      kp.privateKey);
    log(public_key)
    log(private_key)
    return {
      public_key: ab2base64(public_key),
      private_key: ab2base64(private_key),
    };
  }

  create_ingress(pub_key) {
    return this.call_api("POST", "/v1/ingress/create/", {
      pub_key,
    });
  }

  parse_enc_info(ei) {
    return new EncInfo(ei.passphrase, ei.salt, ei.iv);
  }

  ingress_fetch_entries(code) {
    return this.call_api("GET", "/v1/ingress/get-entries/?code=" + code);
  }

  async ingress_decrypt_entry(key, data) {
    var r = await decrypt_with_private_key(key, data);
    var ei = JSON.parse(ab2str(r));
    return this.parse_enc_info(ei);
  }

  async ingress_get_public_key(code) {
    var resp = await this.call_api("GET", "/v1/ingress/get-public-key/?code=" + code);
    return resp.public_key;
  }

  async ingress_submit(code, data, files) {
    var public_key = await this.ingress_get_public_key(code);
    var enc_info = new EncInfo();
    var plain = JSON.stringify(enc_info.json);
    var encrypted = await encrypt_with_public_key(public_key, plain);
    var data_encrypted = await encrypt(enc_info, JSON.stringify(data));
    var enc_buf = Buffer.from(data_encrypted);
    var root_obj_id = obj_id_alloc();
    var refs = [];
    files.forEach(f => {
      refs = refs.concat(f.data.chunks);
    });
    var urls = await this.ingress_objs_alloc(code,
      [{ id: root_obj_id, size: enc_buf.length, refs }]);
    await this.put_raw(urls[0], enc_buf);
    return this.call_api("POST", "/v1/ingress/submit/", {
      code,
      root_obj_id,
      public_key,
      encrypted_data_base64: ab2base64(encrypted),
    });
  }

  ingress_delete_entries(entries) {
    return this.call_api("POST", "/v1/ingress/del-entries/", {
      entries,
    });
  }

  ingress_delete_entry(entry) {
    return this.ingress_delete_entries([entry]);
  }

  async ingress_objs_alloc(code, objs) {
    var r = await this.call_api("POST", "/v1/ingress/objs-alloc/", {
      code,
      objs
    });
    return r.urls;
  }

  async create_space(name, passphrase, gen_recovery_code) {
    assert(passphrase);
    var ei = new EncInfo(passphrase);
    var obj_id = obj_id_alloc();
    var node = new PepperFsDir(this, '', obj_id, ei, null);
    node.initialize_data();
    await node.stage();
    var rc = gen_recovery_code ? this.generate_recovery_code() : null;
    ei = await this.make_space_enc_info(ei, passphrase, rc);
    await this.call_api("POST", "/v1/spaces/", {
      name: name,
      root_obj_id: obj_id,
      enc_info: JSON.stringify(ei),
    });
    return rc;
  }

  fetch_userinfo() {
    if (this._userinfo) {
      return;
    }
    return this.refresh_userinfo();
  }

  async refresh_userinfo() {
    if (!this.authenticated) return;
    try {
      var r = await this.call_api("GET", "/v1/userinfo/")
    } catch(e) {
      if (e.response.status == 401) {
        this.token = null;
      }
      throw e;
    }
    this.parse_userinfo(r);
  }

  call_api(method, uri, data) {
    log("call_api", method, uri);
    var headers = {
      'Accept-Language': "zh-CN",
      'Content-Type': 'application/json',
    };
    if (this.token) {
      headers['Authorization'] = "Token " + this.token;
    }
    return axios({
      method: method,
      url: this.server + uri,
      data: JSON.stringify(data),
      headers: headers,
    }).then(resp => {
      return resp.data;
    }).catch(e => {
      if (this.api_error_cb) {
        this.api_error_cb(e);
      }
      throw e;
    });
  }
}

class Task {
  constructor(type, name, total) {
    this.name = name;
    this.type = type;
    this.total = total;
    this.progress = 0;
    // created, running, done, failed
    this.state = "created";
    this.last_progress = 0;
    this.current_bps = 0;
    this.last_update = null;
    this.start_time = null;
    this.total_time = null;
    this.on_finish = null;
    this.on_error = null;
    this.bps_interval = setInterval(() => {
      this.current_bps = this.progress - this.last_progress;
      this.last_progress = this.progress;
    }, 1000);
  }

  set_state(state) {
    var os = this.state;
    this.state = state;
    if (os == "running" && this.finished) {
      this.current_bps = 0;
      clearInterval(this.bps_interval);
      if (this.on_finish) {
        this.on_finish();
      }
    }
  }

  update(state, progress) {
    this.set_state(state);
    this.progress = progress;
    var last_update = this.last_update;
    this.last_update = new Date();

    if (state == "done") {
      this.total_time = new Date() - this.start_time;
    }

    /* Calculate bps based on last and this update */
    if (!last_update) {
      return;
    }
    var secs = (this.last_update - last_update) / 1000;
    if (secs <= 0) {
      return;
    }
  }

  fail(reason) {
    log("task failed:", reason);
    this.set_state('failed');
    this.error = reason;
    if (this.on_error) {
      this.on_error(this);
    }
  }

  get bps_human() {
    var bps = this.current_bps;
    if (!bps) {
      bps = 0;
    }
    if (bps >= (1 << 20)) {
      return printf("%.1fMB/s", bps / (1 << 20));
    } else if (bps >= (1 << 10)) {
      return printf("%.1fKB/s", bps / (1 << 10));
    } else {
      return printf("%.1fB/s", bps / (1 << 10));
    }
  }

  get percent() {
    if (this.state == "done") {
      return 100;
    }
    if (!this.total) {
      return 0;
    }
    return Math.min(99.9, Math.ceil(this.progress * 100 / this.total));
  }

  get finished() {
    return this.state == "failed" || this.state == "done";
  }

  get succeeded() {
    return this.state == "done";
  }

  get failed() {
    return this.state == "failed";
  }

  get running() {
    return this.state == "running";
  }

  get created() {
    return this.state == "created";
  }

  async gen_thumb(space, obj_id, buf) {
    if (await this.space.fetch('/.mods/thumbs/' + obj_id + '.jpg')) {
      return;
    }
    var img = new Image();
    img.src = 'data:image/jpeg;base64,' + Buffer.from(buf).toString('base64');
    img.onload = async () => {
      var scale;
      if (img.width > img.height) {
        scale = 600 / img.width;
      } else {
        scale = 600 / img.height;
      }
      const elem = document.createElement('canvas');
      var w = img.width * scale;
      var h = img.height * scale;
      elem.width = w;
      elem.height = h;
      const ctx = elem.getContext('2d')
      ctx.drawImage(img, 0, 0, w, h);
      ctx.canvas.toBlob(blob => {
        blob.arrayBuffer().then(buffer => {
          var path = "/.mods/thumbs/" + obj_id + ".jpg";
          this.space.write_file(path, buffer, 'thumb', false);
        });
      }, 'image/jpeg', 0.82);
    }
  }
}

class DownloadTask extends Task {
  constructor(files, writer=null) {
    // For dir download, we calculate actual size later, asynchronously. Just
    // use 1 as a placeholder
    log(files);
    var size = 1;
    if (files.length == 1) {
      var file = files[0];
      if (file.type == "file") {
        size = file.size;
      }
      super("download", file.name, size);
      this.file = file;
    } else {
      var name = files.map(f => f.name).join(",");
      if (name.length > 30) {
        name = name.slice(0, 29) + "...";
      }
      super("download", name, size);
      this.files = files;
    }
    this.path_rel_length = files[0].path.lastIndexOf('/') + 1;
    this.writer = writer;
  }

  gen_archive_name() {
    var t = new Date();
    return printf("批量下载-%04d%02d%02d_%d%02d-%d个文件",
      t.getFullYear(),
      t.getMonth() + 1,
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      this.files.length);
  }

  async start() {
    this.start_time = new Date();
    try {
      if (this.files) {
        await this.download_multi(this.files, this.gen_archive_name());
      } else if (this.file.type == "file") {
        await this.download_file();
      } else if (this.file.type == "dir") {
        await this.download_multi([this.file], this.file.name);
      } else {
        this.fail("Cannot download " + this.file.type);
        return;
      }
    } catch (e) {
      this.fail(e.message);
    }
  }

  async download_file() {
    this.update("running", 0);
    await this.file.populate();
    var data = this.file.data;

    var pos = 0;
    var writer;
    if (this.writer) {
      writer = this.writer;
    } else {
      var ss = require('streamsaver');
      if (!ss.WritableStream) {
        ss.WritableStream = require('web-streams-polyfill').WritableStream;
      }
      var stream = ss.createWriteStream(this.file.name, {
          size: this.file.size // Makes the procentage visible in the download
        });
      writer = stream.getWriter();
    }
    for (var i in data.chunks) {
      var chunk_id = data.chunks[i];
      var buf = await this.file.client.get(chunk_id, this.file.enc_info);
      pos += buf.length;
      await this.write_buf(writer, buf);
      this.update("running", pos);
    }
    writer.close();
    this.update("done", this.file.size);
  }

  async prepare_dir_download_info(files) {
    var info = {
      files: [],
      pos: 0,
      total: 0,
    };
    var queue = files;
    while (queue.length > 0) {
      var n = queue.pop();
      if (n.type == "file") {
        info.files.push(n);
        info.total += n.size;
        continue;
      }
      if (n.type == "dir") {
        await n.populate();
        queue = queue.concat(n.children);
      }
    }
    return info;
  }

  async download_multi(files, name) {
    this.update("running", 0);
    var info = await this.prepare_dir_download_info(files);
    log("download files:", info.files);
    this.total = info.total;
    var streamSaver = require('streamsaver');
    var stream = streamSaver.createWriteStream(name + ".tar", {
      size: info.total,
    });
    var writer = stream.getWriter();
    for (var i = 0; i < info.files.length; i++) {
      var f = info.files[i];
      await this.write_file(info, writer, f);
    }

    await this.write_zeroes(writer, 512 * 2);
    writer.close();

    this.update("done", info.total);
  }

  copy_string(header, pos, str, len) {
    var buf = str2ab(str).slice(0, len);
    for (var i = 0; i < len && i < buf.length; i++) {
      header[pos + i] = buf[i];
    }
  }

  header_checksum(header) {
    var ret = 0;
    for (var i in header) {
      ret += header[i];
    }
    return ret;
  }

  async write_header(writer, f) {
    var header = new Uint8Array(512);
    // name
    this.copy_string(header, 0, f.path.slice(this.path_rel_length), 100);
    // mode
    this.copy_string(header, 100, "000664 ", 8);
    // uid
    this.copy_string(header, 108, "001750 ", 8);
    // gid
    this.copy_string(header, 116, "001750 ", 8);
    // size
    this.copy_string(header, 124, printf("%011o", f.size), 12);
    // mtime
    this.copy_string(header, 136, printf("%011o", f.metadata.mtime / 1000), 12);

    // chksum is calculated with this field filled with ascii space (0x20)
    this.copy_string(header, 148, "        ", 8);

    // type flag
    this.copy_string(header, 156, "0", 1);
    // linkname
    // magic
    this.copy_string(header, 257, "ustar", 6);
    // version
    this.copy_string(header, 263, "00", 2);
    // uname, gname, devmajor, devminor
    this.copy_string(header, 265, "hondcloud", 32);
    this.copy_string(header, 297, "hondcloud", 32);
    this.copy_string(header, 329, "000000", 8);
    this.copy_string(header, 337, "000000", 8);

    // checksum
    var chksum = this.header_checksum(header);
    // here goes the weird chksum value repr
    this.copy_string(header, 148, printf("%06o", chksum), 6);
    this.copy_string(header, 148 + 7, " ", chksum, 6);
    await this.write_buf(writer, header);
  }

  async write_file(info, writer, f) {
    log("write file", f.name);
    await f.populate();
    var data = f.data;

    await this.write_header(writer, f);

    for (var i in data.chunks) {
      var chunk_id = data.chunks[i];
      var buf = await f.client.get(chunk_id, f.enc_info);
      await this.write_buf(writer, buf);
      info.pos += buf.length;
      log(info.pos);
      this.update("running", info.pos);
    }
    if (f.size % 512) {
      await this.write_zeroes(writer, 512 - f.size % 512);
    }
  }

  async write_zeroes(writer, bytes) {
    var buf = new Uint8Array(bytes);
    await writer.write(buf);
  }

  async write_buf(writer, buf) {
    await writer.write(buf);
  }
}

class JobQueue {
  constructor(max_running=1) {
    this.queue = [];
    this.running = 0;
    this.max_running = max_running;
  }

  queue_job(job) {
    this.queue.push(job);
    this.process_queue();
  }

  process_queue() {
    if (!this.queue.length && !this.running) {
      if (this.resolve) {
        this.resolve();
      }
    }
    for (var i = this.running; this.queue.length > 0 && i < this.max_running; i++) {
      this.running++;
      var job = this.queue.shift();
      job().then(() => {
        this.running--;
        this.process_queue();
      }).catch(e => {
        this.running--;
        if (this.reject) {
          this.reject(e);
        }
        this.process_queue();
      });
    }
  }

  wait_all() {
    if (!this.queue.length && !this.running)
      return;
    return new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

function get_file_relative_path(file) {
  return file.webkitRelativePath || file.name;
}

class UploadTask extends Task {
  constructor(space, path, file) {
    super("upload", file.name, file.size);
    this.space = space;
    this.client = space.client;
    this.path = path;
    this.file = file;
    this.chunk_size = 1 << 20;
    this.child = null;
    this.job_queue = new JobQueue(32);
  }

  async upload_chunk(pos, obj_id, enc_info, url) {
    var bytes = Math.min(this.chunk_size, this.file.size - pos);
    var chunk = this.file.slice(pos, pos + bytes);
    var buf = await blob_to_arraybuffer(chunk);
    if (this.running) {
      await this.client.set(obj_id, buf, enc_info, url);
    }
    if (this.running) {
      this.update("running", this.progress + bytes);
    }
  }

  async upload(name) {
    const size = this.file.size;
    var chunks = [];
    this.update("running", 0);
    var enc_info = new EncInfo();
    for (var pos = 0; pos < size; pos += this.chunk_size) {
      var obj_id = obj_id_alloc();
      chunks.push({
        pos: pos,
        id: obj_id,
        size: Math.min(this.chunk_size, size - pos),
      })
    }
    var objs = chunks.map(c => { return {id: c.id, size: c.size}; });
    var urls = await this.client.objs_alloc(objs);
    for (var i = 0; i < chunks.length; i++) {
      var url = urls[i];
      var chunk = chunks[i];
      this.job_queue.queue_job(this.upload_chunk.bind(this, chunk.pos, chunk.id, enc_info, url));
    }
    await this.job_queue.wait_all();
    var metadata = make_metadata(size);
    var fo = new PepperFsFile(this.client, name,
                              obj_id_alloc(), enc_info, null, metadata);
    fo.initialize_data();
    fo.data.chunks = chunks.map(c => c.id);
    return fo;
  }

  get path_in_space() {
    return this.space.dirname(this.space.path_join(this.path, get_file_relative_path(this.file)));
  }

  async upload_finish() {
    var path = this.path_in_space;
    log("await mkdir", path);
    await this.space.mkdir(path, 'upload');
    await this.space.add_child(path, this.child, 'upload');
    log("update done", this.name);
    if (this.space.is_image(this.name)) {
      this.file.arrayBuffer().then(buf => {
        this.gen_thumb(this.space, this.child.obj_id, buf);
      });
    }
    this.update("done", this.file.size);
  }

  check_space() {
    var quota = this.client.quota;
    if (quota) {
      log(quota);
      if (quota.total_space - quota.used_space < this.total) {
        throw new Error("ENOSPC");
      }
    }
  }

  async start() {
    try {
      this.check_space();
      this.start_time = new Date();
      assert(this.state == "created", "Invalid state at start(): " + this.state);
      var name = this.file.name;
      log("upload start", name);
      this.child = await this.upload(name);
      await this.upload_finish();
    } catch (e) {
      log("upload fail", e, name);
      this.fail(e);
    }
  }

  async retry(name) {
    log("upload retry with name", name);
    try {
      this.check_space();
      assert.equal(this.state, 'failed');
      this.space.validate_name(name);
      this.name = name;
      this.update("running", this.progress);
      if (!this.child) {
        this.child = await this.upload(name);
      }
      this.child.name = name;
      await this.upload_finish();
      this.update("done", this.file.size);
    } catch (e) {
      log("upload fail", e, this.name);
      this.fail(e);
    }
  }
}

class IngressUploadTask extends Task {
  constructor(code, client, file) {
    super('upload', file.name, file.size);
    this.file = file;
    this.code = code;
    this.client = client;
    this.file_obj = null;
    this.chunk_size = 1 << 20;
    this.job_queue = new JobQueue(32);
  }

  // TODO: refactor and reuse UploadTask
  async upload_chunk(url, buf) {
    await this.client.put_raw(url, buf);
    this.update("running", this.progress + buf.length);
  }

  async upload() {
    const size = this.file.size;
    var chunks = [];
    this.update("running", 0);
    var enc_info = new EncInfo();
    for (var pos = 0; pos < size; pos += this.chunk_size) {
      var obj_id = obj_id_alloc();
      var bytes = Math.min(this.chunk_size, this.file.size - pos);
      var range = this.file.slice(pos, pos + bytes);
      var buf = await blob_to_arraybuffer(range);
      var encrypted = await encrypt(enc_info, buf);
      var enc_buf = Buffer.from(encrypted);
      chunks.push({
        id: obj_id,
        buf: enc_buf,
        size: enc_buf.length,
      })
    }
    var objs = chunks.map(c => { return {id: c.id, size: c.size}; });
    var urls = await this.client.ingress_objs_alloc(this.code, objs);
    log("chunks", chunks);
    for (var i = 0; i < chunks.length; i++) {
      var url = urls[i];
      var chunk = chunks[i];
      this.job_queue.queue_job(this.upload_chunk.bind(this, url, chunk.buf));
    }
    await this.job_queue.wait_all();
    var metadata = make_metadata(size);
    var fo = new PepperFsFile(this.client, this.file.name,
                              obj_id_alloc(), enc_info, null, metadata);
    fo.initialize_data();
    fo.data.chunks = chunks.map(c => c.id);
    return fo;
  }

  get relative_path() {
    return get_file_relative_path(this.file);
  }

  async start() {
    this.start_time = new Date();
    try {
      this.file_obj = await this.upload();
      this.update("done", this.file.size);
    } catch (e) {
      var msg = "上传失败";
      console.log(e.response.data);
      if (e.response.status == 400 && e.response.data == "EQUOTA") {
        msg = "资源不足";
      }
      this.fail(msg);
    }
  }
}

class ThumbsTask extends Task {
  constructor(client, space) {
    super('thumbs', space.name, -1);
    this.space = space;
    this.should_stop = false;
    this.visited = new Set();
  }

  async start() {
    log("thumbs generation started");
    var cur = await this.space.fetch('/');
    if (!cur) {
      log("thumbs generation failed, cannot get root node");
      this.fail('ENOENT');
      return;
    }
    var queue = [cur];
    while (!this.should_stop && queue.length) {
      cur = queue.shift();
      await cur.populate();
      for (var c of cur.children) {
        log("thumbs checking", c.path);
        if (c.path == "/.mods") {
          continue;
        }
        if (c.type == "dir") {
          queue.push(c);
          continue;
        }
        if (!this.space.is_image(c.name)) {
          continue;
        }
        var buf = await this.space.read_file(c.path);
        await this.gen_thumb(this.space, c.obj_id, buf);
        this.visited.add(c.obj_id);
        if (this.should_stop) {
          break;
        }
      }
    }
  }
}

module.exports = {
  PepperClient,
  DownloadTask,
  UploadTask,
  IngressUploadTask,
  ThumbsTask,
}
